import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const KlubIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "KlubIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M20.6338 12.0901C21.5827 11.2492 22.1781 10.0384 22.1781 8.69339C22.1781 6.15207 20.0489 4.09009 17.4211 4.09009C16.266 4.09009 15.2056 4.48885 14.3809 5.15207L14.3767 5.1562C14.343 5.18306 13.23 6.1562 12.1802 7.07562C11.1303 6.1562 10.0173 5.18306 9.98367 5.1562L9.97946 5.15207C9.15472 4.48885 8.09644 4.09009 6.93928 4.09009C4.31146 4.09009 2.18018 6.15207 2.18018 8.69546C2.18018 10.0384 2.77769 11.2492 3.72657 12.0901C2.77769 12.9331 2.18018 14.1417 2.18018 15.4868C2.18018 18.0302 4.31146 20.0901 6.93928 20.0901C8.09434 20.0901 9.15472 19.6913 9.97946 19.0281L9.98367 19.024C10.0173 18.9971 11.1303 18.024 12.1802 17.1046C13.23 18.024 14.343 18.9971 14.3767 19.024L14.3809 19.0281C15.2056 19.6913 16.2639 20.0901 17.4211 20.0901C20.0489 20.0901 22.1802 18.0281 22.1802 15.4868C22.1802 14.1417 21.5848 12.9331 20.6359 12.0901H20.6338ZM6.93928 6.50951C7.61674 6.50951 8.10275 6.77604 8.3952 7.00538C8.56141 7.15001 9.37984 7.86488 10.3287 8.69546C9.38194 9.52397 8.56141 10.2409 8.3952 10.3855C8.10065 10.6169 7.61464 10.8814 6.93928 10.8814C5.67271 10.8814 4.64388 9.9 4.64388 8.69546C4.64388 7.49091 5.67481 6.50951 6.93928 6.50951ZM8.3973 17.1769C8.10275 17.4083 7.61674 17.6727 6.94138 17.6727C5.67481 17.6727 4.64599 16.6913 4.64599 15.4868C4.64599 14.2822 5.67691 13.3008 6.94138 13.3008C7.61674 13.3008 8.10275 13.5674 8.3973 13.7967C8.56351 13.9413 9.38194 14.6562 10.3308 15.4868C9.38405 16.3153 8.56351 17.0322 8.3973 17.1769ZM10.1499 12.0901C10.5012 11.7843 11.3596 11.0322 12.1823 10.3132C13.1333 9.48058 14.0316 8.69339 14.0316 8.69339C14.9805 7.86488 15.7989 7.14794 15.9652 7.00331C16.2597 6.77191 16.7457 6.50744 17.4211 6.50744C18.6876 6.50744 19.7165 7.48885 19.7165 8.69339C19.7165 9.89794 18.6855 10.8793 17.4211 10.8793C16.266 10.8793 15.2056 11.2781 14.3809 11.9413L14.3767 11.9455C14.3704 11.9517 14.2126 12.088 14.2126 12.088C14.2126 12.088 13.0028 13.1459 12.1802 13.8649C11.3596 13.1459 10.5012 12.3959 10.1478 12.088L10.1499 12.0901ZM17.4211 17.6727C16.7457 17.6727 16.2597 17.4062 15.9652 17.1769C15.7989 17.0322 14.9805 16.3174 14.0316 15.4868C14.9784 14.6583 15.7989 13.9413 15.9652 13.7967C16.2597 13.5653 16.7457 13.3008 17.4211 13.3008C18.6876 13.3008 19.7165 14.2822 19.7165 15.4868C19.7165 16.6913 18.6855 17.6727 17.4211 17.6727Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default KlubIcon;
